import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Rating } from "@mui/material";
import "./EditReviewComponent.scss";
import { Close, StarRounded } from "@mui/icons-material";
import { submitReview } from "../../../api/details-page.api";

interface EditReviewComponentProps {
  onClose: () => void;
  partnerId: number;
  selectedReview: any;
  onSubmitSuccess: () => void;
}

const EditReviewComponent: React.FC<EditReviewComponentProps> = ({
  onClose,
  partnerId,
  selectedReview,
  onSubmitSuccess,
}) => {
  const [rating, setRating] = useState<number | "">("");
  const [description, setDescription] = useState("");
  const [ratingError, setRatingError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [submitError, setSubmitError] = useState("");

  const onWriteClose = () => {
    setRating("");
    setDescription("");
    onClose();
  };
  useEffect(() => {
    if (selectedReview) {
      setRating(selectedReview?.rating);
      setDescription(selectedReview?.description);
    } else {
      setRating("");
      setDescription("");
    }
  }, [selectedReview]);

  const handleSubmit = async () => {
    let hasError = false;
    if (!rating) {
      setRatingError("Rating is required.");
      hasError = true;
    } else {
      setRatingError("");
    }
    if (!description.trim()) {
      setDescriptionError("Description is required.");
      hasError = true;
    } else {
      setDescriptionError("");
    }

    if (hasError) {
      return;
    }

    try {
      await submitReview({
        partnerId,
        description,
        rating: Number(rating),
      });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      onSubmitSuccess();
      onWriteClose();
    } catch (err) {
      setSubmitError("Failed to submit review. Please try again.");
      console.error(err);
    }
  };

  return (
    <Box className="edit-review-card">
      <Box className="edit-review-body">
        <Box className="rating-section">
          <Rating
            name="rating"
            value={typeof rating === "number" ? rating : 0}
            onChange={(event, newValue) => {
              setRating(newValue || "");
              setRatingError("");
              setSubmitError("");
            }}
            size="large"
            icon={<StarRounded fontSize="inherit" />}
            emptyIcon={
              <StarRounded style={{ opacity: 0.55 }} fontSize="inherit" />
            }
          />
          {ratingError && <Box className="error-text">{ratingError}</Box>}
        </Box>
        <Box
          className="review-section"
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderWidth: "1px",
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
            "& .MuiFormHelperText-root": {
              margin: 0,
              padding: 0,
              lineHeight: "16px",
            },
          }}
        >
          <Typography className="review-label">Your Review *</Typography>
          <TextField
            multiline
            rows={2}
            variant="outlined"
            placeholder="Share your experience..."
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              setDescriptionError("");
              setSubmitError("");
            }}
            fullWidth
            error={!!descriptionError}
            helperText={descriptionError}
          />
        </Box>
        {submitError && <Box className="submit-error-text">{submitError}</Box>}
      </Box>
      <Box className="edit-review-actions">
        <Button className="submit-review-btn" onClick={handleSubmit}>
          Update Review
        </Button>
        <Button className="cancel-btn" onClick={onWriteClose}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default EditReviewComponent;
